import { Seccion } from './../../../models/usuarios.model';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { DocumentoOficialResponse } from 'app/modules/admin/documentos-oficiales/models/documento-oficial.model';
import { CONSTANTS } from 'app/core/constants';
import { CompletarGestionInterface } from 'app/models/completar-gestion.model';

@Injectable({providedIn: 'root'})

export class CompletarGestionService {

    constructor(private apiService: ApiService) { }

    getListaDocumentoOficial(gestionUuid?: string){
        let params={ status: CONSTANTS.ID_DOCUMENTOS_ESTADO_CERTIFICADO, gestionUuid: gestionUuid }
        const url=`/documento_generado` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, params, 'Error al obtener los documentos.')
                .subscribe((response: DocumentoOficialResponse) => {
                    resolve(response.data)                    
                }, error => {
                    reject(true)
                })
        })
    }

    postDocumentosGestion(body:any, tareaUuid:string, ){
        const url=`/tareas/subir_documentos/${tareaUuid}`
        return new Promise((resolve, reject)=>{
            this.apiService.PostMethod(url, body, {}, 'Error al guardar documento oficial.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(true)
                })
        })
    }

    postAprobarGestion(body:CompletarGestionInterface){
        const url=`/gestion/finalizar_gestion`
        return new Promise((resolve, reject)=>{
            this.apiService.PostMethod(url, body, {}, 'Error al completar gestión.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(true)
                })
        })
    }
    
}